import { useState } from 'react'

import { FiltersContextInterface } from '../contexts/Filters'
import { Filters } from '../../types/general'

const defaultCryptocurrency = {
  name: 'Bitcoin',
  code: 'BTC',
}

const defaultFiat = {
  name: 'EUR',
  code: '€',
}

const defaultDeposit = {
  name: 'USDC',
  code: 'USDC',
}

const defaultRegion = {
  name: 'Europe',
  fiat: defaultFiat,
}

const defaultFilter = {
  cryptocurrency: defaultCryptocurrency,
  order: 'price',
  fiat: defaultFiat,
  depositCryptocurrency: defaultDeposit,
  depositInput: 100,
  depositPeriod: '1',
  region: defaultRegion,
}

const useFilters = (): FiltersContextInterface => {
  const [filters, setFilters] = useState<Filters>(defaultFilter as Filters)

  const saveFilter = (filter: Partial<Filters>) => {
    setFilters({
      ...filters,
      ...filter,
    })
  }

  return {
    filters,
    setFilter: saveFilter,
  }
}

export default useFilters
